'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var LoadingTransitionManager = function LoadingTransitionManager(_ref) {
    var isLoading = _ref.isLoading,
        isSuccessful = _ref.isSuccessful,
        loadingTransitionError = _ref.loadingTransitionError,
        InitialComponent = _ref.InitialComponent,
        LoadingComponent = _ref.LoadingComponent,
        SuccessComponent = _ref.SuccessComponent,
        ErrorComponent = _ref.ErrorComponent,
        props = _objectWithoutProperties(_ref, ['isLoading', 'isSuccessful', 'loadingTransitionError', 'InitialComponent', 'LoadingComponent', 'SuccessComponent', 'ErrorComponent']);

    var RenderComponent = void 0;

    if (loadingTransitionError && ErrorComponent) {
        RenderComponent = ErrorComponent;
    } else if (isLoading) {
        RenderComponent = LoadingComponent;
    } else if (isSuccessful) {
        RenderComponent = SuccessComponent;
    } else {
        RenderComponent = InitialComponent;
    }

    return _react2.default.createElement(RenderComponent, props);
};

LoadingTransitionManager.propTypes = {
    InitialComponent: _propTypes2.default.func.isRequired,
    LoadingComponent: _propTypes2.default.func.isRequired,
    SuccessComponent: _propTypes2.default.func.isRequired,
    ErrorComponent: _propTypes2.default.func,
    isLoading: _propTypes2.default.bool,
    isSuccessful: _propTypes2.default.bool,
    loadingTransitionError: _propTypes2.default.any
};

exports.default = LoadingTransitionManager;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/loaders/LoadingTransitionDisplay.js
// module id = 438
// module chunks = 0